import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import AddCurriculumFields from "../../components/curriculum/AddCurriculumFields";
import { useLocation } from "react-router-dom";
import AddJournalFields from "../../components/Journals/AddJournalsFields";
// import { AddCategoriesHooks } from "./hooks/CategoriesHooks";

const AddCurriculumModal = ({ isOpen, onClose, rowData,hideUI,   reloadData,
    setReloadData,church ,selectedJournals}) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
//   const { videoInputs, setVideoInputs } = AddVideosHooks();
    // lock body scroll when modal open
//   useEffect(() => {
//     if (rowData) {
//       setVideoInputs((prev) => ({
//         ...prev,
//         ...rowData, // fill all fields with rowData
//       }));
//     } else {
//       // reset if opening modal for new video
//       setVideoInputs({});
//     }
//   }, [rowData, setVideoInputs]);
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = isOpen ? "hidden" : prev;
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex justify-end items-center ${
        isOpen ? "" : "pointer-events-none"
      }`}
      aria-hidden={!isOpen}
    >
      {/* Backdrop */}
      <div
        onClick={onClose}
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ease-out ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
      />

      {/* Modal Panel */}
      <div
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        className={`relative bg-[#1f1f1f] text-white shadow-2xl transform transition-all duration-500 ease-in-out rounded-md
          ${isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
        style={{ width: "85%", height: "90%" }}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-700 sticky top-0 bg-[#1f1f1f] z-10">
          <h2 className="text-lg font-semibold">Add Journal</h2>
          <button onClick={onClose} className="p-1">
            <IoCloseOutline className="text-2xl" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">
          <div className="MAIN-CONTENT flex flex-col gap-4">
          <AddJournalFields selectedJournals={selectedJournals} church={church} setLoading={setLoading} rowData={rowData} isLoading={loading} hideUI={hideUI} onClose={onClose} reloadData={reloadData} setReloadData={setReloadData}/>

            {/* <AddCategoryFields
              setLoading={setLoading}
              data={rowData?._id ? { _id: rowData._id } : {}}
              onClose={onClose}
            hideUI={hideUI}
            setReloadData={setReloadData}
            reloadData={reloadData}
              rowData={rowData ? rowData : {}}
            /> */}
            {/* <AddCurriculumFields setLoading={setLoading} hideUI={hideUI} onClose={onClose} rowData={rowData}/> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCurriculumModal;
